export default "__VITE_ASSET__BkD7u303__"